import { render, staticRenderFns } from "./InstagramFeed.vue?vue&type=template&id=19a3fc72&scoped=true"
import script from "./InstagramFeed.vue?vue&type=script&lang=js"
export * from "./InstagramFeed.vue?vue&type=script&lang=js"
import style0 from "./InstagramFeed.vue?vue&type=style&index=0&id=19a3fc72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a3fc72",
  null
  
)

export default component.exports